exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3pQwWThtPAixrVDMSyAoXe {\n  background: #ddd;\n  border-radius: 1rem;\n  display: flex;\n  flex-flow: row wrap;\n  max-width: 100%;\n  position: relative;\n  padding: 1rem 0 0 1rem;\n}\n._3mT9a8Nk72HSo_eTORLgds {\n  flex: 0 0 auto;\n  margin-right: 1rem;\n  margin-bottom: 1rem;\n}\n._2fS4vvA9ufilZNiDxtfvaq {\n  cursor: pointer;\n}\n._2fS4vvA9ufilZNiDxtfvaq:hover {\n  background: #cfcfcf;\n}\n", ""]);

// exports
exports.locals = {
	"card-group": "_3pQwWThtPAixrVDMSyAoXe",
	"card": "_3mT9a8Nk72HSo_eTORLgds",
	"clickable": "_2fS4vvA9ufilZNiDxtfvaq"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/card-group.styl
 ** module id = 267
 ** module chunks = 0
 **/